import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>My Fair Share</h3>
          <p>
            Free UK PAYE tax calculator. Calculate your take-home pay and 
            explore what-if tax scenarios.
          </p>
        </div>

        <div className="footer-section">
          <h3>Legal</h3>
          <nav aria-label="Legal links">
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/terms">Terms &amp; Conditions</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/blog">Blog</Link></li>
            </ul>
          </nav>
        </div>

        <div className="footer-section">
          <h3>Resources</h3>
          <nav aria-label="Resource links">
            <ul>
              <li><Link to="/blog">Tax Guides & Articles</Link></li>
              <li>
                <a href="https://www.gov.uk/income-tax-rates" target="_blank" rel="noopener noreferrer">
                  HMRC Tax Rates
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {currentYear} My Fair Share. All rights reserved.</p>
        <p className="footer-disclaimer">
          This tool provides estimates only. Not financial advice.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
